import store from "../store";
import { SEARCH_BUSINESS_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class SearchBusinessClass {
  private getState() {
    return store.getState().searchBusiness;
  }

  constructor() { }

  // this function will be called when the user clicks on the search button
  public setSearchType(handler: Function): this {
    // Reset search results when changing the type
    store.dispatch(
      SEARCH_BUSINESS_UPDATE({
        data: {
          search: "",
          searchResults: [],
        },
      }),
    );

    handler("");
    return this;
  }

  // this function will be called when the user starts typing in the search bar
  public setSearchQuery(search: string): this {

    if (search === "") {
      store.dispatch(
        SEARCH_BUSINESS_UPDATE({
          data: {
            search: "",
            searchResults: [],
          },
        }),
      );
      return this;
    }
    // set the search query in the store
    store.dispatch(
      SEARCH_BUSINESS_UPDATE({
        data: {
          search: search,
          searchResults: this.getState().searchResults,
        },
      }),
    );

    console.log("search query:", this.getState().search);

    this.performSearch();
    return this;
  }

  public async performSearch() {
    try {
      console.log("performing search wit hthis search:", this.getState().search);
      let endpoint = "search/brands-and-venues?searchTerm=" + this.getState().search;
      const data = {
        endpoint,
      };

      console.log("getting search results with this data:", data);

      const res = await DatabaseInstance.getRecord(data);

      console.log("search results:", res);

      store.dispatch(
        SEARCH_BUSINESS_UPDATE({
          data: {
            search: this.getState().search,
            searchResults: res,
          },
        }),
      );
    } catch (error) {
      console.error("Search error:", error);
    }
  }
}

const SearchBusinessInstance = new SearchBusinessClass();
export { SearchBusinessInstance };
